import { useMemo, useState } from 'react'
import { IconCheck, IconPlus } from './components/Icons'
import { getColorName } from './utils/colorNames'
import './SimpleColorPalette.css'

/** פלטת צבעים פשוטה — לחיצה על צבע מחליפה מיד. sensitivePress = בחירה במגע/לחיצה מיד, אזור גדול יותר. easyMode = אזור מגע גדול (לילדים) */
export function SimpleColorPalette({
  colors,
  currentColor,
  onSelect,
  onAddColor,
  onMixColors,
  sensitivePress,
  easyMode,
  lang = 'he',
}) {
  const [showMixer, setShowMixer] = useState(false)
  const [mixColor1, setMixColor1] = useState('#ff0000')
  const [mixColor2, setMixColor2] = useState('#0000ff')
  const [mixRatio, setMixRatio] = useState(0.5)

  const mixedHex = useMemo(() => {
    if (typeof onMixColors === 'function') return onMixColors(mixColor1, mixColor2, mixRatio)
    return currentColor
  }, [onMixColors, mixColor1, mixColor2, mixRatio, currentColor])

  const addMixedColor = () => {
    if (typeof onAddColor === 'function') onAddColor(mixedHex)
    onSelect(mixedHex)
    setShowMixer(false)
  }

  const handleSelect = (hex) => onSelect(hex)
  return (
    <div className={`simple-palette ${sensitivePress ? 'sensitive-press' : ''} ${easyMode ? 'easy-mode' : ''}`}>
      {colors.map((hex) => (
        (() => {
          const name = getColorName(hex, lang)
          return (
        <button
          key={hex}
          type="button"
          className={`simple-swatch ${hex === currentColor ? 'selected' : ''}`}
          style={{ background: hex }}
          onClick={() => handleSelect(hex)}
          onPointerDown={sensitivePress ? (e) => { e.preventDefault(); handleSelect(hex); } : undefined}
          title={name}
          aria-label={name}
          data-speak={name}
        >
          {hex === currentColor && <span className="simple-swatch-check"><IconCheck size={16} /></span>}
        </button>
          )
        })()
      ))}
      {typeof onAddColor === 'function' && (
        <button
          type="button"
          className="simple-swatch simple-swatch-add"
          onClick={() => setShowMixer((v) => !v)}
          title={lang === 'en' ? 'Mix / create color' : 'ערבב / צור צבע חדש'}
          aria-label={lang === 'en' ? 'Mix and create a new color' : 'ערבוב ויצירת צבע חדש'}
        >
          <IconPlus size={18} />
        </button>
      )}
      {showMixer && (
        <div className="simple-palette-mixer" role="group" aria-label={lang === 'en' ? 'Color mixer' : 'מיקסר צבעים'}>
          <label className="simple-palette-mixer-color">
            <span>{lang === 'en' ? 'Color A' : 'צבע א'}</span>
            <input type="color" value={mixColor1} onChange={(e) => setMixColor1(e.target.value)} />
          </label>
          <label className="simple-palette-mixer-ratio">
            <span>{lang === 'en' ? 'Mix ratio' : 'יחס ערבוב'}</span>
            <input
              type="range"
              min="0"
              max="1"
              step="0.05"
              value={mixRatio}
              onChange={(e) => setMixRatio(Number(e.target.value))}
            />
          </label>
          <label className="simple-palette-mixer-color">
            <span>{lang === 'en' ? 'Color B' : 'צבע ב'}</span>
            <input type="color" value={mixColor2} onChange={(e) => setMixColor2(e.target.value)} />
          </label>
          <button
            type="button"
            className="simple-palette-mixer-add"
            onClick={addMixedColor}
            style={{ background: mixedHex }}
            title={lang === 'en' ? `Add ${mixedHex}` : `הוסף ${mixedHex}`}
          >
            {lang === 'en' ? 'Add mixed color' : 'הוסף צבע מעורבב'}
          </button>
        </div>
      )}
    </div>
  )
}
